export function parseType<T>(key: string, data: any): T {
  return data[key].items as T;
}
